/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iconik_Proxy_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "External Project Import Failed. {error}" |
*
* @param {Iconik_Proxy_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_failed_toast = /** @type {((inputs: Iconik_Proxy_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'importation du projet externe. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Import des externen Projekts fehlgeschlagen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione progetto esterno non riuscita. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт внешнего проекта не удался. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la importación del proyecto externo. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`外部项目导入失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`外部プロジェクトのインポートに失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`बाह्य परियोजना आयात विफल। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A importação do projeto externo falhou. ${i?.error}`)
	return /** @type {LocalizedString} */ (`External Project Import Failed. ${i?.error}`)
});